import type { MetricTabName } from "app/pages/benchmark-tracker/config";
import { BenchmarkMetricName } from "app/pages/benchmark-tracker/types/api.types";

import AudienceReach from "../MetricElements/AudienceReach/AudienceReach";
import RankingWidget from "../MetricElements/RankingWidget/RankingWidget";
import { TrafficShare } from "../MetricElements/TrafficShare/TrafficShare";

import { getModalColumns } from "./getModalColumns";
import type { ComponentSchema, MetricMappingSchema } from "./types";
import { MetricFormat } from "app/common/benchmark/types";

const overviewTabMetrics: MetricMappingSchema[] = [
    {
        name: BenchmarkMetricName.trafficShare,
        format: MetricFormat.percent,
        title: "",
        tooltip: `bt.metrics.tooltip.text.share.${BenchmarkMetricName.trafficShare}`,
        secondaryTooltip: `bt.metrics.tooltip.text.total.${BenchmarkMetricName.trafficShare}`,
        Component: ({ tooltip, secondaryTooltip, onOpenModal, name }: ComponentSchema) => (
            <TrafficShare
                tooltip={tooltip}
                secondaryTooltip={secondaryTooltip}
                onOpenModal={onOpenModal}
                name={name}
            />
        ),
        modalColumnsConfig: getModalColumns.trafficShare,
    },
    {
        name: BenchmarkMetricName.visits,
        format: MetricFormat.numberAbbr,
        title: `bt.metrics.title.${BenchmarkMetricName.visits}`,
        tooltip: `bt.metrics.tooltip.text.${BenchmarkMetricName.visits}`,
        Component: RankingWidget,
        modalColumnsConfig: getModalColumns.visits,
    },
    {
        name: BenchmarkMetricName.audienceReach,
        format: MetricFormat.percentSign,
        title: `bt.metrics.title.${BenchmarkMetricName.audienceReach}`,
        tooltip: `bt.metrics.tooltip.text.${BenchmarkMetricName.audienceReach}`,
        Component: ({ tooltip, title, name, format, onOpenModal }: ComponentSchema) => (
            <AudienceReach
                tooltip={tooltip}
                title={title}
                name={name}
                format={format}
                onOpenModal={onOpenModal}
            />
        ),
        modalColumnsConfig: getModalColumns.audienceReach,
    },
];

const engagementTabMetrics: MetricMappingSchema[] = [
    {
        name: BenchmarkMetricName.visitDuration,
        format: MetricFormat.time,
        title: `bt.metrics.title.${BenchmarkMetricName.visitDuration}`,
        tooltip: `bt.metrics.tooltip.text.${BenchmarkMetricName.visitDuration}`,
        Component: RankingWidget,
        modalColumnsConfig: getModalColumns.visitDuration,
    },
    {
        name: BenchmarkMetricName.bounceRate,
        format: MetricFormat.percentSign,
        title: `bt.metrics.title.${BenchmarkMetricName.bounceRate}`,
        tooltip: `bt.metrics.tooltip.text.${BenchmarkMetricName.bounceRate}`,
        Component: RankingWidget,
        modalColumnsConfig: getModalColumns.bounceRate,
    },
    {
        name: BenchmarkMetricName.pagesPerVisit,
        format: MetricFormat.number,
        title: `bt.metrics.title.${BenchmarkMetricName.pagesPerVisit}`,
        tooltip: `bt.metrics.tooltip.text.${BenchmarkMetricName.pagesPerVisit}`,
        Component: RankingWidget,
        modalColumnsConfig: getModalColumns.pagesPerVisit,
    },
    {
        name: BenchmarkMetricName.pageViews,
        format: MetricFormat.numberAbbr,
        title: `bt.metrics.title.${BenchmarkMetricName.pageViews}`,
        tooltip: `bt.metrics.tooltip.text.${BenchmarkMetricName.pageViews}`,
        Component: RankingWidget,
        modalColumnsConfig: getModalColumns.pageViews,
    },
];

export const metrics: Record<MetricTabName, MetricMappingSchema[]> = {
    overview: overviewTabMetrics,
    engagement: engagementTabMetrics,
};

export { METRICS_BY_CONTROLLER } from "./metricsByController";
